import fetchJsonp from 'fetch-jsonp';
import { adaptCountryResorts } from './adapter';
import type { ApiCountryResortsResponse } from './types';
import { useTravelataAppConfig } from '@/shared/composables/useTravelataAppConfig';
import type { Country, Resort } from '@/shared/model';

const inFlight = new Map<number, Promise<ApiCountryResortsResponse>>();

export function clearCountryResortsCache(): void {
  inFlight.clear();
}

function buildResortsUrl(base: string, countryId: number): string {
  const separator = base.includes('?') ? '&' : '?';
  return `${base}${separator}country=${encodeURIComponent(String(countryId))}`;
}

export function fetchCountryResorts(countryId: number): Promise<ApiCountryResortsResponse> {
  const shared = inFlight.get(countryId);
  if (shared !== undefined) {
    return shared;
  }

  const request: Promise<ApiCountryResortsResponse> = requestCountryResorts(countryId).catch(() => {
    if (inFlight.get(countryId) === request) {
      inFlight.delete(countryId);
    }
    return [] as ApiCountryResortsResponse;
  });
  inFlight.set(countryId, request);
  return request;
}

async function requestCountryResorts(countryId: number): Promise<ApiCountryResortsResponse> {
  const config = useTravelataAppConfig();
  const url = buildResortsUrl(config.gatewayUrl + config.getResorts, countryId);

  const response = await fetchJsonp(url);
  const body = await response.json<ApiCountryResortsResponse>();

  if (body.success !== true) {
    throw new Error('getCountryResorts: ответ не success');
  }
  return body;
}

export async function getCountryResorts(country?: Pick<Country, 'id' | 'name'> | undefined | null): Promise<Resort[]> {
  if (!country) return [];
  const data = await fetchCountryResorts(country.id);
  return adaptCountryResorts(data.data || [], country);
}
